<router-outlet></router-outlet>
<cars-toasts aria-live="polite" aria-atomic="true"></cars-toasts>
<cars-spinner *ngIf="isLoader()"></cars-spinner>